import { getApiUrl, AXIOS_ADMIN_AUTHED } from './shared';
import { serializeAsQueryString } from '../../utils/utils';
import { constructPageString } from '../../utils/api-util';

const IMITABLE_EMPLOYEES_BASE_URL = `${getApiUrl()}/employees/imitable`;

const DEFAULT_SEARCH = {
  firstName: null,
  lastName: null,
  branchCode: null,
  role: null
};

const DEFAULT_PAGEABLE = {
  page: {
    size: 0,
    number: 0
  },
  sortBy: {
    name: 'branchCode',
    direction: 'asc'
  }
};

const search = (criteria = DEFAULT_SEARCH, pageable = DEFAULT_PAGEABLE) => {
  const pageString = constructPageString(pageable);
  const queryString = buildQueryString(criteria);
  return AXIOS_ADMIN_AUTHED.get(
    `${IMITABLE_EMPLOYEES_BASE_URL}?${pageString}&${queryString}`
  );
};

const getToken = (employeeId) => {
  return AXIOS_ADMIN_AUTHED.get(
    `${IMITABLE_EMPLOYEES_BASE_URL}/${employeeId}/imitate`
  );
};

const addBranchOverride = ({
  branchId,
  branchCode,
  employeeId,
  approvalTier,
  validUntil
}) => {
  return AXIOS_ADMIN_AUTHED.post(
    `${IMITABLE_EMPLOYEES_BASE_URL}/add-override`,
    {
      branchId,
      branchCode,
      employeeId,
      approvalTier,
      validUntil
    }
  );
};

const removeBranchOverride = ({ branchId, employeeId }) => {
  return AXIOS_ADMIN_AUTHED.post(
    `${IMITABLE_EMPLOYEES_BASE_URL}/remove-override`,
    {
      branchId,
      employeeId
    }
  );
};

const buildQueryString = (criteria) => {
  return serializeAsQueryString(criteria, true);
};

export { search, getToken, addBranchOverride, removeBranchOverride };
